var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1174"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1174"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34726",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};